import { Box, BoxProps, Typography } from "@mui/material";

export default function Welcome(props: BoxProps) {
  return (
    <Box {...props}>
      <Typography variant="h2" mb={3}>
        Welcome to MAITE
      </Typography>
      <Typography mb={3}>
        MAITE is your virtual Marketing Analytics Insights and Trends Expert, designed to help you
        easily explore and analyze data within GrowthOS.
      </Typography>
      <Typography>Here are some questions you might like to ask MAITE:</Typography>
    </Box>
  );
}
